module.exports = __webpack_public_path__ + "static/media/New Land.f83c259d.jpg";